import { render } from "./Import_Share_Accounts.vue?vue&type=template&id=0955bd9c"
import script from "./Import_Share_Accounts.vue?vue&type=script&lang=js"
export * from "./Import_Share_Accounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__